import { Dropdown } from "react-bootstrap";
import styles from "./mobilejournalview.module.css";
import { ChevronLeft, Edit, MoreVertical, Trash2, } from "react-feather";
import { Link } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import dayjs from "dayjs";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";
import { useState } from "react";
import VideoThumbnail from "../VideoThumbnail";
import { useAuth0 } from "@auth0/auth0-react";

const MobileJournalView = ({ journalDetails, setDeleteModalOpen, setOpenEditForm }) => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const { user, isAuthenticated } = useAuth0();

    const videoExtensions = ["mp4", "mov", "avi", "mkv", "webm"];

    return (<>
        <div className={`${styles.UserMainDiv}`}>
            <Link className={`${styles.BackAddBU}`} to={"/security/journal/list"}><ChevronLeft /></Link>
            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 || user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1) && <Dropdown className={`${styles.ProEditSec}`}>
                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                    <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setOpenEditForm(true)}>
                        <Edit /> Edit
                    </Dropdown.Item>}
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen(true)}>
                        <Trash2 /> Delete
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>}
            <div className={`${styles.DetailTopSec}`}>
                {journalDetails?.images?.length > 0 && <div className={`${styles.RequestCarouselSec} RequestCarouselSec`}>
                    <Carousel autoPlay={true} showThumbs={false} showArrows={false} showStatus={false} interval="3000">
                        {journalDetails?.images?.map((item, index) => {
                            const extension = item?.image_url.split(".").pop().split("?")[0].toLowerCase();
                            return (videoExtensions.includes(extension)) ? (<div onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }}>
                                <VideoThumbnail videoUrl={item?.image_url} />
                            </div>) : (<div onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }}>
                                <img src={item?.image_url} alt="" />
                            </div>)
                        })}
                    </Carousel>
                </div>}
                {/* {journalDetails?.images?.length === 0 && <div className={`${styles.RequestCarouselSec} RequestCarouselSec`}>
                    <div>
                        <img src={"/static/img/journalImg1.jpg"} alt="" style={{ width: '100%' }} />
                    </div>
                </div>} */}
            </div>
            <div className={styles.AccordionSecMain}>
                <ul className={`${styles.CaseSummSideUL}`}>
                    <li>
                        <p className={`${styles.ULtitle}`}>Any unusual activities or events to report</p>
                        <p className={`${styles.ULData}`}>{journalDetails?.is_unusual === 1 ? "Yes" : "No"}</p>
                    </li>
                    <li>
                        <p className={`${styles.ULtitle}`}>Submitted Date</p>
                        <p className={`${styles.ULData}`}>{dayjs(journalDetails?.date).format("MM/DD/YYYY")}</p>
                    </li>
                    <li>
                        <p className={`${styles.ULtitle}`}>Property</p>
                        <p className={`${styles.ULData}`}>{journalDetails?.property_name}</p>
                    </li>
                    <li>
                        <p className={`${styles.ULtitle}`}>Tenant(s)</p>
                        <p className={`${styles.ULData}`}>{journalDetails?.tenant_names}</p>
                    </li>
                    <li>
                        <p className={`${styles.ULtitle}`}>Note</p>
                        <div className={`${styles.ULData}`} dangerouslySetInnerHTML={{ __html: journalDetails?.description }}></div>
                    </li>
                </ul>
            </div>
        </div>

        <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            index={lightboxIndex}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={journalDetails?.images?.map(i => {
                const extension = i?.image_url.split(".").pop().split("?")[0].toLowerCase();
                if (videoExtensions.includes(extension)) {
                    return {
                        type: "video",
                        sources: [
                            {
                                src: i?.image_url
                            },
                        ]
                    }
                }
                return { src: i?.image_url }
            })}
            plugins={[Video]}
        />
    </>);
};

export default MobileJournalView;